import numeral from 'numeral'
import moment from 'moment-timezone'

moment.tz.setDefault('Asia/Tokyo')

// バイト単位フィルタ
export function bytes (value) {
  return numeral(value).format('0.0 ib')
}

// ISO8601・UTC・ミリ秒を通常の時刻表示にする
export function datetime (value) {
  return value ? moment(value).format('YYYY/MM/DD HH:mm:ss') : '-'
}
